import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import DropdownSelect from '../../components/dropdown-select';
import StickyBar from '../../components/sticky-bar';
import Collapse from '../../components/collapse';
$(() => {
    RevealWhenVisible.init();
    DropdownSelect.init();
    StickyBar.init();
    Collapse.init();
});
